import React from "react";
import webImage from "./../img/webImage.jpg";
import bootstrapweb from "./../img/bootstrap web.png";
import Cocktails from "./../img/cocktails.png";
import glassweb from "./../img/glassweb.png";
import notebook from "./../img/notebook.png";
import stripeMenu from "./../img/stripe menu.png";
import weTheFoodies from "./../img/wethefoodie.png";
import "../index.css";
const about = () => {
  return (
    <div className="mt-5">
      <section className="body-font">
        <h1 className="fw-bold text-center">My Projects</h1>
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-wrap -m-4">
            <div className="card2 p-4 md:w-1/3">
              <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                <img
                  className="lg:h-48 md:h-36 w-full object-cover object-center"
                  src={weTheFoodies}
                  alt="blog"
                />
                <div className="p-6">
                  <h2 className="tracking-widest text-xs title-font font-medium  -400 mb-1">
                    HTML/CSS
                  </h2>
                  <h1 className="title-font text-lg font-medium mb-3">
                    We The Foodies
                  </h1>
                  <p className="leading-relaxed mb-3">
                    Dear diet, things just aren’t looking good for the both of
                    us. It’s not me, it’s you. You’re too much work. You’re
                    boring and I can’t stop cheating on you.
                  </p>
                  <div className="flex items-center flex-wrap ">
                    <a
                      className="text-red-500 inline-flex items-center md:mb-2 lg:mb-0"
                      href="https://github.com/Shaharyar07/Web-projects/tree/main/WeTheFoodies"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Go to Repository
                      <svg
                        className="w-4 h-4 ml-2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                    </a>
                    <span className=" mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      3.2K
                    </span>
                    <span className="  inline-flex items-center leading-none text-sm">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                      </svg>
                      44
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="card2 p-4 md:w-1/3">
              <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                <img
                  className="lg:h-48 md:h-36 w-full object-cover object-center"
                  src={glassweb}
                  alt="blog"
                />
                <div className="p-6">
                  <h2 className="tracking-widest text-xs title-font font-medium  -400 mb-1">
                    HTML/CSS
                  </h2>
                  <h1 className="title-font text-lg font-medium  -900 mb-3">
                    The Glass website
                  </h1>
                  <p className="leading-relaxed mb-3">
                    “It’s better to die on your feet than to live on your
                    knees.” <br />
                    “We fail, We Break, We Fall but then We Rise, We Heal, We
                    Overcome.”
                  </p>
                  <div className="flex items-center flex-wrap">
                    <a
                      className="text-red-500 inline-flex items-center md:mb-2 lg:mb-0"
                      href="https://github.com/Shaharyar07/Web-projects/tree/main/glass-web"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Go to Repository
                      <svg
                        className="w-4 h-4 ml-2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                    </a>
                    <span className="  mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      2.7K
                    </span>
                    <span className="  inline-flex items-center leading-none text-sm">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                      </svg>
                      21
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="card2 p-4 md:w-1/3">
              <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                <img
                  className="lg:h-48 md:h-36 w-full object-cover object-center"
                  src={bootstrapweb}
                  alt="blog"
                />
                <div className="p-6">
                  <h2 className="tracking-widest text-xs title-font font-medium  -400 mb-1">
                    React Bootstrap
                  </h2>
                  <h1 className="title-font text-lg font-medium  mb-3">
                    Bootcamp - a bootstrap website
                  </h1>
                  <p className="leading-relaxed mb-3">
                    Bootstrap is a free and open-source CSS framework directed
                    at responsive, mobile-first front-end web development.It
                    contains CSS- and JavaScript-based design templates
                  </p>
                  <div className="flex items-center flex-wrap ">
                    <a
                      className="text-red-500 inline-flex items-center md:mb-2 lg:mb-0"
                      href="https://github.com/Shaharyar07/portfolio-projects/tree/main/bootstrap-web"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Go to Repository
                      <svg
                        className="w-4 h-4 ml-2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                    </a>
                    <span className="  mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      69K
                    </span>
                    <span className=" inline-flex items-center leading-none text-sm">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                      </svg>
                      33
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className=" body-font">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-wrap -m-4">
            <div className="card2 p-4 md:w-1/3">
              <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                <img
                  className="lg:h-48 md:h-36 w-full object-cover object-center"
                  src={Cocktails}
                  alt="blog"
                />
                <div className="p-6">
                  <h2 className="tracking-widest text-xs title-font font-medium  -400 mb-1">
                    React Js
                  </h2>
                  <h1 className="title-font text-lg font-medium  -900 mb-3">
                    The Cocktails
                  </h1>
                  <p className="leading-relaxed mb-3">
                    It is an react based JavaScript project that fetches the
                    Cocktails using external Api and UseReducer and useContext
                    Hooks
                  </p>
                  <div className="flex items-center flex-wrap">
                    <a
                      className="text-red-500 inline-flex items-center md:mb-2 lg:mb-0"
                      href="https://github.com/Shaharyar07/portfolio-projects/tree/main/cocktails"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Go to Repository
                      <svg
                        className="w-4 h-4 ml-2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                    </a>
                    <span className=" mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      9.2K
                    </span>
                    <span className=" inline-flex items-center leading-none text-sm">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                      </svg>
                      33
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="card2 p-4 md:w-1/3">
              <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                <img
                  className="lg:h-48 md:h-36 w-full object-cover object-center"
                  src={stripeMenu}
                  alt="blog"
                />
                <div className="p-6">
                  <h2 className="tracking-widest text-xs title-font font-medium  -400 mb-1">
                    React Js
                  </h2>
                  <h1 className="title-font text-lg font-medium  -900 mb-3">
                    The Stripe Menu
                  </h1>
                  <p className="leading-relaxed mb-3">
                    It is an react based JavaScript project that is basically
                    the clone of landing page of stripe website.It is a great
                    practice to make amazing landing pages
                  </p>
                  <div className="flex items-center flex-wrap ">
                    <a
                      className="text-red-500 inline-flex items-center md:mb-2 lg:mb-0"
                      href="https://github.com/Shaharyar07/portfolio-projects/tree/main/13-stripe-submenus/final"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Go to Repository
                      <svg
                        className="w-4 h-4 ml-2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                    </a>
                    <span className=" mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      9K
                    </span>
                    <span className=" inline-flex items-center leading-none text-sm">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                      </svg>
                      444
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="card2 p-4 md:w-1/3">
              <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                <img
                  className="lg:h-48 md:h-36 w-full object-cover object-center"
                  src={notebook}
                  alt="blog"
                />
                <div className="p-6">
                  <h2 className="tracking-widest text-xs title-font font-medium  -400 mb-1">
                    MERN Stack
                  </h2>
                  <h1 className="title-font text-lg font-medium  -900 mb-3">
                    iNotebook
                  </h1>
                  <p className="leading-relaxed mb-3">
                    iNotebook is a Full Stack application based on Mern stack to
                    store your notes on cloud.It is a fully functional
                    JavaScrpit project
                  </p>
                  <div className="flex items-center flex-wrap ">
                    <a
                      className="text-red-500 inline-flex items-center md:mb-2 lg:mb-0"
                      href="https://github.com/Shaharyar07/portfolio-projects/tree/main/inotebook"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Go to Repository
                      <svg
                        className="w-4 h-4 ml-2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                    </a>
                    <span className=" mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      9.2K
                    </span>
                    <span className=" inline-flex items-center leading-none text-sm">
                      <svg
                        className="w-4 h-4 mr-1"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                      </svg>
                      111
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="container  border shadow-sm p-5 mb-5  rounded py-5  body-font">
        <h1 className="mt-2 text-center fw-bold "> Description</h1>
        <div className="container mx-auto flex  py-2 md:flex-row flex-col items-center">
          <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <div className="body-font">
              <div className="container px-5 py-24 mx-auto">
                <div className="xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="inline-block w-8 h-8  -400 mb-8"
                    viewBox="0 0 975.036 975.036"
                  >
                    <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
                  </svg>
                  <p className="leading-relaxed text-lg">
                    Currently pursuing comprehensive four-year course of study
                    in Bachelor of science in software engineering, laying solid
                    groundwork for eventual career in Software Engineering.
                  </p>
                  <span className="inline-block h-1 w-10 rounded bg-indigo-500 mt-8 mb-6"></span>
                  <h2 className=" -900 font-medium title-font tracking-wider text-sm">
                    Comsats University Islamabad.
                  </h2>
                  <p className="">Mern Stack Developer</p>
                </div>
              </div>
            </div>
          </div>
          <div className="img-fluid  lg:max-w-lg lg:w-50 md:w-1/2 w-5/6">
            <img alt="hero" src={webImage} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default about;
